module.exports = __webpack_public_path__ + "static/media/family_14.f37e8077.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_14.jpg
// module id = 5846
// module chunks = 0